import { Col, Row, Skeleton } from 'antd';
import { useLastHelpItems } from '@/core/domain/helpcenter/HelpItems/HelpItems.hooks';
import HelpItemCard from '@/components/HelpCenter/HelpItemCard';
import HelpAreaList from '@/components/HelpCenter/HelpAreaList';
import HelpItemFavoritesList from '@/components/HelpCenter/HelpItemFavoritesList';

function HelpCenterHomePage() {
  const lastHelpItems = useLastHelpItems();

  return (
    <div style={{ maxWidth: 1400, margin: '0 auto' }}>
      <>
        {!!lastHelpItems.data?.data?.length && (
          <Row
            gutter={[24, 24]}
            style={{ marginTop: -60, zIndex: 1, position: 'relative' }}
            justify="center"
          >
            {lastHelpItems.data.data.map((item) => (
              <Col span={24} md={12} lg={6} key={item.id}>
                <HelpItemCard helpItem={item} key={item.id} />
              </Col>
            ))}
          </Row>
        )}

        {lastHelpItems.isLoading && (
          <Row
            gutter={[24, 24]}
            style={{ marginTop: -60, zIndex: 1, position: 'relative' }}
            justify="center"
          >
            {Array.from({ length: 4 }).map((_, index) => (
              <Col span={24} md={12} lg={6} key={index}>
                <Skeleton.Button
                  active
                  style={{ minWidth: 335, height: 180, borderRadius: 8 }}
                />
              </Col>
            ))}
          </Row>
        )}

        <HelpAreaList />

        <HelpItemFavoritesList />
      </>
    </div>
  );
}

export default HelpCenterHomePage;
